import React from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { MessageSquareIcon } from 'lucide-react';

interface ObservationsSectionProps {
  readOnly?: boolean;
}

const ObservationsSection = ({ readOnly = false }: ObservationsSectionProps) => {
  const { register } = useFormContext();

  return (
    <div className="form-group">
      <Label className="form-label flex items-center gap-2">
        <MessageSquareIcon size={16} />
        Observaciones
      </Label>
      <Textarea 
        {...register('services.serviceNotes')}
        className="form-textarea min-h-[120px]"
        placeholder="Ingrese observaciones sobre los servicios del establecimiento..."
        disabled={readOnly}
      />
    </div>
  );
};

export default ObservationsSection;
